import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Field, Form, FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'
import CustomInput from '../../../components/common/CustomInput'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const validationSchema = Yup.object({
    name: Yup.string().required("Name is Required")
})

const Add = () => {
    const navigate = useNavigate()

    const handleSubmit = async (values, { resetForm }) => {
        try {
          const response = axiosAuthInstance.post('library-category/add', {
            name: values.name,
          })
          if (response) {
            navigate('/librarycategory')
          }
        } catch (error) {
          console.error(error)
        }
      }
      const formik = useFormik({
        onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
        validationSchema,
        initialValues: {
          name: '',
        },
      })
  return (
    <FormikProvider value={formik}>
          <form
            className='flex flex-col p-4 gap-4'
            onSubmit={(e) => {
              e.preventDefault()
              formik.handleSubmit()
            }}
          >
            <Field
              name='name'
              label='Name'
              placeholder='Name'
              required
              component={CustomInput}
            />
    
            <button
              type='submit'
              disabled={formik.isSubmitting}
              // onClick={addItem}
              className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
            >
              Add
            </button>
          </form>
        </FormikProvider>
  );
}

export default Add;
